import type { RouteRecordRaw } from 'vue-router'
import CurrentDialogPage from '../../modules/dialog/pages/CurrentDialogPage.vue'
import ConductedDialogsPage from '../../modules/dialog/pages/ConductedDialogsPage.vue'
import CoacheePrepareDialogPage from '../../modules/dialog/pages/CoacheePrepareDialogPage.vue'
import DialogPage from '../../modules/dialog/pages/DialogPage.vue'
import PrepareSuperpowerSlide from '@/modules/dialog/components/PrepareSuperpowerSlide.vue'
import PrepareJournalSlide from '@/modules/dialog/components/PrepareJournalSlide.vue'
import PrepareEvaluationSlide from '@/modules/dialog/components/PrepareEvaluationSlide.vue'
import PreparePulseSlide from '@/modules/dialog/components/PreparePulseSlide.vue'
import DialogStartSlide from '@/modules/dialog/components/DialogStartSlide.vue'
import FinalSuperpowerSlide from '@/modules/dialog/components/FinalSuperpowerSlide.vue'
import FinalJournalSlide from '@/modules/dialog/components/FinalJournalSlide.vue'
import FinalEvaluationSlide from '@/modules/dialog/components/FinalEvaluationSlide.vue'
import FinalPulseSlide from '@/modules/dialog/components/FinalPulseSlide.vue'
import FinalObjectiveSlide from '@/modules/dialog/components/FinalObjectiveSlide.vue'
import PrintDialogPage from '@/modules/dialog/pages/PrintDialogPage.vue'
import ObjectivesPage from '@/modules/dialog/pages/ObjectivesPage.vue'
import ArchivedObjectivesPage from '@/modules/dialog/pages/ArchivedObjectivesPage.vue'

export const dialogRoutes: RouteRecordRaw[] = [
  {
    path: '/dialog',
    name: 'dialogs',
    component: CurrentDialogPage,
  },
  {
    path: '/conducted-dialogs',
    name: 'conducted-dialogs',
    component: ConductedDialogsPage,
  },
  {
    path: '/objectives',
    name: 'objectives',
    component: ObjectivesPage,
  },
  {
    path: '/objectives/archived',
    name: 'archived-objectives',
    component: ArchivedObjectivesPage,
  },
  {
    path: '/dialog/coachee-prepare/:id',
    name: 'coachee-prepare-dialog',
    redirect: { name: 'prepare-start-slide' },
    component: CoacheePrepareDialogPage,
    meta: {
      layout: 'full-screen',
    },
    children: [
      {
        path: 'start',
        name: 'prepare-start-slide',
        component: DialogStartSlide,
      },
      {
        path: 'superpower/:feedbackTopicId',
        name: 'prepare-superpower-slide',
        component: PrepareSuperpowerSlide,
      },
      {
        path: 'journal/:feedbackTopicId',
        name: 'prepare-journal-slide',
        component: PrepareJournalSlide,
      },
    ],
  },
  {
    path: '/dialog/:id',
    name: 'dialog',
    redirect: { name: 'start-slide' },
    component: DialogPage,
    meta: {
      layout: 'full-screen',
    },
    children: [
      {
        path: 'start',
        name: 'start-slide',
        component: DialogStartSlide,
      },
      {
        path: 'superpower/:feedbackTopicId',
        name: 'superpower-slide',
        component: FinalSuperpowerSlide,
      },
      {
        path: 'journal/:feedbackTopicId',
        name: 'journal-slide',
        component: FinalJournalSlide,
      },
      {
        path: 'evaluation/:feedbackTopicId',
        name: 'evaluation-slide',
        component: FinalEvaluationSlide,
      },
      {
        path: 'pulse/:feedbackTopicId',
        name: 'pulse-slide',
        component: FinalPulseSlide,
      },
      {
        path: 'objectives',
        name: 'objectives-slide',
        component: FinalObjectiveSlide,
      },
      {
        path: 'evaluation-prepare/:feedbackTopicId',
        name: 'prepare-evaluation-slide',
        component: PrepareEvaluationSlide,
      },
      {
        path: 'pulse-prepare/:feedbackTopicId',
        name: 'prepare-pulse-slide',
        component: PreparePulseSlide,
      },
    ],
  },
  {
    path: '/print-dialog',
    name: 'print-dialog',
    component: PrintDialogPage,
    meta: {
      isPublic: true,
      layout: 'print',
    },
  },
]
